export const CHAT_BOT_TEXT_UTILS = {
  TITLE: "NeumoBot",
  INPUT_LABEL: "Haz una pregunta..."
};

export const CHAT_BOT_ROLES = {
  USER: "user",
  ASSISTANT: "assistant",
  FUNCTION_ROLE: "function"
};

export const CHAT_ACTIONS = {
  OPEN_CHAT: "OPEN_CHAT",
  CLOSE_CHAT: "CLOSE_CHAT",
  START_SPEECH_RECORD: "START_SPEECH",
  STOP_SPEECH_RECORD: "STOP_SPEECH"
};

export const CHAT_ERRORS = {
  ERROR_RESPONSE: "Lo sentimos el chat no se encuentra disponible.",
  ACTION_ERROR: "Lo sentimos esta accion no esta disponible."
};

export const CHAT_ACTIONS_RESPONSES = {
  SEARCHING: "searching data",
  NAVEGATING_TO: "navegating",
  NAVIGATION_ERROR_404: "page not found"
};

export const NEWCHAT_EMITED = "newChatMsg";

export const LOGIN_PATH = "/login";

export const CHAT_INIT_MSG =
  "Eres un asistente virtual de la clínica Neumomed, tu objetivo es dar información clara y concisa a los pacientes de la clínica, estas son tus funciones: 1. solo responder a dudas que puedan tener relacionadas a la clínica, información de la misma como formularios, pacientes y citas médicas o con base a las funciones que se están dando en este mensaje. 2. cualquier petición que necesite análisis y/o cálculos con o sin información de la clínica o pacientes. 3. Debes mantener el contexto de la conversación para los pacientes y tener presente siempre la información ya consultada en funciones para resolver dudas antes de realizar nuevas consultas las funciones disponibles. Debes permanecer en este rol y no salirte de este bajo ninguna circunstancia.";
